<template>
  <section
    class="available-offices container"
    id="available-offices"
    v-animate-in
  >
    <div class="flex justify-between mb-4">
      <h2 class="h3">Blog</h2>
      <router-link class="flex gap-1 no-underline	" to="/blog#enter">
        Tovább
        <ArrowRight />
      </router-link>
    </div>
    <div class="posts" id="posts">
      <BlogPostCard v-for="post in posts" :key="post.id" :post="post" />
    </div>
  </section>
</template>

<script>
import BlogPostCard from "@/components/BlogPostCard";
import ArrowRight from "@/components/icons/ArrowRight";
import axios from "axios";
import qs from "qs";

export default {
  name: "FreshPosts",
  components: {
    BlogPostCard,
    ArrowRight
  },
  data() {
    return {
      posts: []
    };
  },
  methods: {
    async getPosts() {
      const query = {
        populate: ["coverImage", "tags"],
        sort: ["publishedAt:desc"],
        pagination: {
          limit: 3,
          start: 0
        }
      };

      try {
        return axios.get(`blog-posts?${qs.stringify(query)}`);
      } catch (e) {
        // console.log(e);
      }
    }
  },
  async mounted() {
    const posts = await this.getPosts();
    this.posts = posts.data.data;
  }
};
</script>

<style lang="scss">
.available-offices {
  margin-top: 100px !important;
}
.posts {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 30px;
  row-gap: 30px;
  padding-bottom: 60px;
}
@media screen and (min-width: 550px) {
  .container {
    .content {
      .posts {
        padding: 16px;
        grid-template-columns: 1fr 1fr;
      }
    }
  }
}
@media screen and (min-width: $breakpoint) {
  .posts {
    grid-template-columns: 1fr 1fr 1fr;
    padding: 0px;
    padding-bottom: 90px;
  }
}
</style>
